import { render, staticRenderFns } from "./wxl-search-box.vue?vue&type=template&id=03676220&scoped=true"
import script from "./wxl-search-box.vue?vue&type=script&lang=js"
export * from "./wxl-search-box.vue?vue&type=script&lang=js"
import style0 from "./wxl-search-box.vue?vue&type=style&index=0&id=03676220&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03676220",
  null
  
)

export default component.exports